import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawFacebookIcon from "./RawFacebookIcon.svg.jsx";

const FacebookIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawFacebookIcon} {...props} />;
});

export default FacebookIcon;
